/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// Live URL
// const BASE_URL = "http://test.VTS.com"

// Local Testing Url
 // const BASE_URL = "localhost:80"
 const BASE_URL = 'https://vtsapi.dhanushinfotech.com';
export const environment = {
  production: false,
       apiBaseUrl: BASE_URL + '/api/user/',
       apireportUrl: BASE_URL + '/api/reports/',

    // Localhost Url

 // apiBaseUrl: BASE_URL + '/VTS/api/user/',
  X_API_KEY: 'FEA3E5D0QFCEBFD54F0A6A674ECAE3F8',

  // RCM Base URL
  rcmBaseUrl: BASE_URL + '/api/rcm/',

  // Route Planner Base URL
  route_planner_base_url: BASE_URL + '/api/routeplanner/',

  // Bus
  busApiBaseUrl: BASE_URL + '/api/bus/',

  // BusScheduler
  busschedulerApiBaseUrl: BASE_URL + '/api/busscheduler/',


   // BusStudent
  StudentApiBaseUrl: BASE_URL + '/api/student/',

     // Routes
     RoutesApiBaseUrl: BASE_URL + '/api/Busroute/',


  // Products Base URL
  apiBaseUrlProduct: BASE_URL + '/api/products/',


  // USER_ANALYTICS
  user_analytics_constants: {
    // EVENT_TYPES
    EVENT_TYPE_LOGIN: 'Login',
    EVENT_TYPE_LOGOUT: 'Logout',
    EVENT_TYPE_SCREEN_VIEW: 'ScreenView',
    EVENT_TYPE_DOWNLOAD_REPORT: 'DownloadReport',
    EVENT_TYPE_OTHERS: 'Others',

    // REPORT_TYPES
    REPORT_TYPE_PDF: 'PDF',
    REPORT_TYPE_EXCEL: 'EXCEL',
    REPORT_TYPE_EMPTY: '',

    // MAP_TYPES
    MAP_CONTAINS_YES: 'Yes',
    MAP_CONTAINS_NO: 'No',

    MODULES: {
      HOME: {
        MODULE_NAME: 'Home',
        SCREEN_DASHBOARD: 'Dashboard',
        SCREEN_LIVE_TRACK: 'LiveTrack',
        SCREEN_TRACK_HISTORY: 'TrackHistory',
        SCREEN_SUMMARY_REPORT: 'SummaryReport',
      },
      SMART_LINKS: {
        MODULE_NAME: 'SmartLinks',
        RoutePlanner: 'RoutePlanner',
        TollPlazaInfo: 'TollPlazaInfo',
        FuelPriceInfo: 'FuelPriceInfo',
        FuelDashboard: 'FuelDashboard',
        TemperatureDashboard: 'TemperatureDashboard',
        FuelCompleteDetailsReport: 'FuelCompleteDetailsReport',
        FuelSummaryVehicleWise: 'FuelSummaryVehicleWise',
        FuelSummaryDayWise: 'FuelSummaryDayWise',
        FuelRefillsVehicleWise: 'FuelRefillsVehicleWise',
        FuelRefillsDayWise: 'FuelRefillsDayWise',
        FuelRemovalsVehicleWise: 'FuelRemovalsVehicleWise',
        FuelRemovalsDayWise: 'FuelRemovalsDayWise',
        FuelRefillReport: 'FuelRefillReport',
        FuelDailyReport: 'FuelDailyReport',
        FuelSummaryReport: 'FuelSummaryReport',
        FuelRemovalReport: 'FuelRemovalReport',
        FuelRawDataReport: 'FuelRawDataReport',
      },
      MY_ACCOUNT: {
        MODULE_NAME: 'MyAccount',
        MyProfile: 'MyProfile',
        MyWallet: 'MyWallet',
        MyTrips: 'MyTrips',
        MyGeofence: 'MyGeofence',
        MySharedUsers: 'MySharedUsers',
        MyGroups: 'MyGroups',
        MyDrivers: 'MyDrivers',
        FastTag: 'FastTag',
      },
      REPORTS_CHARTS: {
        REPORTS_CHARTS_MENU: 'ReportsChartsMenu',
        MODULE_NAME: 'ReportsCharts',
        STOPPAGE_REPORT: 'StoppageReport',
        TRACK_REPORT: 'TrackReport',
        DISTANCE_REPORT: 'DistanceReport',
        DAYWISE_REPORT: 'DailyKMReport',
        DAILY_SUMMARY_KM_REPORT: 'DailySummaryKMReportAllVehicles',
        T24Hours_REPORT: '24HoursKMReport',
        T24Hours_Analysis_REPORT: '24HoursAnalysisReport',
        GEOFENCE_REPORT: 'GeofenceReport',
        GEOFENCE_TO_GEOFENCE_REPORT: 'GeofenceToGeofenceReport',
        DRIVER_PERFORMANCE_REPORT: 'DriverPerformance',
        TRACK_NEAREST_REPORT: 'TrackNearestVehicle',
        CHARTS_REPORT: 'Charts',
        SUMMARY_REPORT: 'SummaryReport',
        TEMPERATURE_REPORT: 'TemperatureReport',
        FUEL_REPORT: 'FuelReport',
        IGNITION_REPORT: 'IgnitionReport',
        DASHBOARD_REPORT: 'DashboardReport',
        KILOMETER_SUMMARY_REPORT: 'KilometerSummaryManagement',
        ALL_POSITIONS_REPORT: 'AllPositionsReport',
        OVER_SPEED_REPORT: 'OverSpeedReport',
        DOOR_SENSOR_REPORT: 'DoorSensorReport',
        GENERATOR_REPORT: 'GenSetReport',
        MonthlyWayPointsReport: 'MonthlyWayPointsReport',

      },
      FLEET_MANAGEMENT: {
        FLEETS_MENU: 'FleetManagementMenu',
        MODULE_NAME: 'FleetManagement',
        VechicleManagement: 'FullVehicleDetails',
        ServiceManagement: 'ServiceHistoryManagement',
        FuelManagement: 'FuelSlipManagement',
        Routes: 'Routes',
        DriverManagement: 'DriverManagement',
        TyreManagement: 'TyreManagement',
        SparePartManagement: 'SparePartManagement',
        KilometerSummaryManagement: 'KilometerSummaryManagement',
        CustomerManagement: 'CustomerManagement',
        ExpansesManagement: 'ExpansesManagement',
        TripManagement: 'TripManagement',
        HubManagement: 'HubManagement',
        CompanyManagement: 'CompanyManagement',
      },
      ALERTS: {
        ALERTS_MENU: 'AlertsMenu',
        MODULE_NAME: 'Alerts',
        BasicNotifications: 'BasicNotifications',
        LessKilometerTravelAlerts: 'LessKMTravelAlerts',
        StopeedMoreThan3HoursAlerts: 'StoppedMoreThan3HoursAlerts',
        DataNotReceivedAlerts: 'DataNotReceivedAlerts',
        TemperatureAlerts: 'TemperatureAlerts',
        GeofenceAlerts: 'GeofenceAlerts',
        SpeedViolationAlerts: 'SpeedViolationAlerts',
        DoorSensorAlerts: 'DoorSensorAlerts',
        FuelAlerts: 'FuelAlerts',
        IgnitionAlerts: 'IgnitionAlerts',
        LowBatteryAlerts: 'LowBatteryAlerts',
        VehicleCertificateRenewalAlerts: 'VehicleCertificateRenewalAlerts',
        ServiceReminderAlerts: 'ServiceReminderAlerts',
        TripManagementAlerts: 'TripManagementAlerts',
        DriverChangeAlerts: 'DriverChangeAlerts',
        GPSLockAlerts: 'GPSLockAlerts',
      },
      GPS_LOCK: {
        MODULE_NAME: 'GPSLock',
        GPS_LOCK: 'GPSLock',
      },
      OTHERS: {
        MODULE_NAME: 'Others',
        SETTINGS: 'Settings',
        CONTACT_US: 'ContactUs',
        HELP: 'Help',
        REFER_EARN: 'ReferEarn',
      },
    },
  },

};
